import { useState, useEffect, useCallback } from 'react';
import { Surcharge } from '../types/costwand'; // Assuming Surcharge is the lookup item
import { apiClient, ApiError } from '../api/apiClient.tsx';

interface UseSurchargeLookupResult {
  surcharges: Surcharge[];
  loading: boolean;
  error: string | null;
  fetchSurcharges: () => Promise<void>;
}

export const useSurchargeLookup = (): UseSurchargeLookupResult => {
  const [surcharges, setSurcharges] = useState<Surcharge[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchSurcharges = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await apiClient<{ data: Surcharge[] }>('/surcharges', { allPages: true });
      setSurcharges(response.data);
    } catch (err) {
      if (err instanceof ApiError) {
        setError(`Failed to fetch surcharges: ${err.message}`);
      } else {
        setError('An unknown error occurred while fetching surcharges.');
      }
      setSurcharges([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchSurcharges();
  }, [fetchSurcharges]);

  return {
    surcharges,
    loading,
    error,
    fetchSurcharges,
  };
};